module.exports = require("core-js/library/fn/weak-set");